
import React from 'react';
import { HorizontalAlignment, Kitchen } from '@rta/rta-blueprint-library';

import { RenderPanelShadow } from './render-panel-shadow';

type RenderPanelShadowsProps = {
	kitchen: Kitchen;
	islandId: string;
	panelId: string;
};
export const RenderPanelShadows = (props: RenderPanelShadowsProps): React.ReactElement => {
	// const {
	// 	controller: { options }
	// } = useContext(AppContext);
	const { kitchen, islandId, panelId } = props;

	const island = kitchen.design.islands.findById(islandId);
	const panel = island.panels.findById(panelId);

	// something went wrong
	if (!panel) return <></>;

	// dont process is no island is present or the island doesn't have an overlap
	if (!panel.isFrontPanel || !(island.isLeftOverlap || island.isRightOverlap)) return <></>;
	// console.log('ShowOverlap', island.isLeftOverlap ? 'Left Overlap' : 'Right Overlap');

	// other calculations
	// const { thickness: countertopThickness } = kitchen.material.countertop;
	// const applianceOpacity = options.blueprintToApplianceView === 100 ? 1 : 0.75;

	// gather details about the overlapping island
	const oIslandConnection = island.connections.children.find((con) =>
		con.sourcePanelId === panel.id && con.horizontalAlign === (island.isRightOverlap ? HorizontalAlignment.right : HorizontalAlignment.left));
	const oIsland = oIslandConnection?.targetIsland;

	/* there is more than 10" padding between islands, so don't show the shadow */
	if (!oIslandConnection || !oIsland || oIslandConnection.padding < 0 || oIslandConnection.padding > 10) return <></>;

	// baseSize is a calculated property, so let only reference it once
	const { islandSize } = island;
	const { islandSize: oIslandSize } = oIsland;

	// offset to start the overhang
	// const offsetX = island.isRightOverlap
	// 	? islandSize.width - oIslandSize.depth - oFrontOverhang
	// 	: -(islandSize.width - oIslandSize.depth) / 2;
	// const offsetY = islandSize.height - oIslandSize.height - countertopThickness;
	const offsetX = island.isRightOverlap
		? (islandSize.width / 2) - (oIslandSize.depth / 2) + oIslandConnection.offset //  + oBackOverhang
		: -(islandSize.width / 2) + (oIslandSize.depth / 2) + oIslandConnection.offset; // - oFrontOverhang;

	// const offsetY = (islandSize.height - oIslandSize.height) / 2;

	/* the connection offset has shifted the adjoining island clear of this panel, so there is nothing to shadow */
	if (Math.abs(offsetX) >= (islandSize.width / 2) + (oIslandSize.depth / 2)) return <></>;

	// console.log('render:show-overlap:', { island, oIsland, offsetX, offsetY, opacity: options.applianceOpacity });

	return (
		<g transform={`translate(${offsetX}, 0)`}
			fill="gray" opacity={1}
			type="island-shadow"
		>
			<RenderPanelShadow
				islandId={oIsland.id}
				panelId={island.isRightOverlap ? oIsland.frontPanel.connections.right.targetPanelId : oIsland.frontPanel.connections.left.targetPanelId}
			/>
		</g>
	);
};
